export default "__VITE_ASSET__LC5w2EAN__"